import { Icon } from "../../../assets";
import { SelectorTypes } from "../components/Selector/Selector.types";

type Links = {
 linkAppGooglePlay: string;
 linkAppAppleStore: string;
 linkManual?: string;
 linkVideoYouTube: string;
 linkGuideApp: string;
 linkGuideMaintenance: string;
 linkCecotecSupport: string;
 linkGuideStart: string;
};

export function getLinks(links: Links): SelectorTypes.Props[] {
 return [
  {
   id: "linkAppGooglePlay",
   title: "Android",
   text: "Descargar App",
   icon: Icon.Android,
   link: links.linkAppGooglePlay || "",
  },
  {
   id: "linkAppAppleStore",
   title: "iOS",
   text: "Descargar App",
   icon: Icon.Ios,
   link: links.linkAppAppleStore || "",
  },
  {
   id: "linkManual",
   title: "Manual de instrucciones",
   text: "Ver manual de instrucciones",
   icon: Icon.Manual,
   link: links.linkManual || "",
  },
  {
   id: "linkGuideStart",
   title: "Guía de inicio rápido",
   text: "Tu dispositivo listo en pocos pasos",
   icon: Icon.Link,
   link: links.linkGuideStart || "",
  },
  {
   id: "linkVideoYouTube",
   title: "Vincula paso a paso",
   text: "Ver video",
   icon: Icon.Video,
   link: links.linkVideoYouTube || "",
  },
  {
   id: "linkGuideApp",
   title: "Guía de la app",
   text: "Cómo usar a aplicación",
   icon: Icon.Mobile,
   link: links.linkGuideApp || "",
  },
  {
   id: "linkGuideMaintenance",
   title: "Guía de mantenimiento",
   text: "Como limpiar tu producto",
   icon: Icon.Clean,
   link: links.linkGuideMaintenance || "",
  },
  {
   id: "linkCecotecSupport",
   title: "Soporte CecoCare",
   text: "Un link, todas las soluciones",
   icon: Icon.StandbyOff,
   link: links.linkCecotecSupport || "",
  },
 ];
}
